import React, { useState, useEffect } from 'react';
import { Button, Space, Breadcrumb, Input } from 'antd';
import classNames from 'classnames';
import { CardLayout, SortableTable, RefCodeEditModal } from 'components/molecules';
import { useRefCode } from 'hooks';
import { ColumnsType } from 'antd/lib/table/interface';
import { TotalNumMenu } from 'components/atoms';
import { usePopupManager } from 'react-popup-manager';
import * as XLSX from 'xlsx';
const cx = classNames.bind('./index.scss');

export interface LectureSubjectProps {}

const LectureSubject = ({}: LectureSubjectProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [tableDatas, setTableDatas] = useState<any[]>([]);
  const [title] = useState<string>('강의주제');
  const [fieldName] = useState<string>('lecture_subject1');
  const { open } = usePopupManager();
  const [searchInput, setSearchInput] = useState<string>('');
  const [filterValue, setFilterValue] = useState<string>('');

  const columns: ColumnsType<RefCodeListDto> = [
    {
      key: 'sort',
      width: '70px',
      align: 'center',
    },  
    {
      title: title + '명',
      dataIndex: 'value',
      key: 'value',
      width: 'auto',
      align: 'left',
      render: (value, record) => {
        return (
          <span style={{color:record.status_type === 'AV'?'#000':'#f00'}}>{value}</span>
        )
      }        
    },
    {
      title: '생성일',
      dataIndex: 'created',
      key: 'created',
      width: '120px',
      align: 'center',
    },    
    {
      title: '사용여부',
      dataIndex: 'status_type',
      key: 'status_type',
      width: '80px',
      align: 'center',
      render: (status_type, record) => {
        return (
          <Button
            type='default'
            onClick={(e) => {
              e.stopPropagation();

              refCodeUpdate({ref_code_srl: record.ref_code_srl, status_type: status_type === 'AV'?'HD':'AV'})
            }}
          >{status_type === 'AV' ? 'YES' : 'NO'}</Button>
        )
      }
    }, 
  ];
    
  /* ======================================================
   * hooks
   * ====================================================== */
  const { refCodeList, refCodeInsert, refCodeUpdate, refCodeSort } = useRefCode({field:fieldName});  

  /* ======================================================
   * events
   * ====================================================== */    
   const onSort = (active: string | number, over: string | number)  => {
    refCodeSort({active: active as number, over: over as number})
  }

  const onClickRegister = () => {
    open(RefCodeEditModal, {
      title: title,
      ref_code_srl: 0,
      useCreate: true,      
      onClose: (isOk, value, create) => {
        if (isOk) {
          refCodeInsert({
            field: fieldName,
            name_alias: 'S',
            value: value,
            created: create,            
          })    
        }
      },
    }); 
  }

  const onRowClick = (record: any) => {
    open(RefCodeEditModal, {
      title: title,      
      ref_code_srl: record.ref_code_srl,
      value: record.value,
      created: record.created,
      useCreate: true,      
      onClose: (isOk, value, created) => {
        if (isOk) {
          refCodeUpdate({ref_code_srl: record.ref_code_srl, value: value, created: created})   
        }
      },
    });   
  }  

  const onDownloadExcel = () => {
    if (!!refCodeList) {
      const book = XLSX.utils.book_new();
    
      const nurses = XLSX.utils.json_to_sheet(
        refCodeList.filter(item=> filterValue ? item.value.includes(filterValue):true).map((item, index) => {
          return {
            '강의주제명' : item.value,
            '생성일' : item.created,            
            '사용여부': item.status_type === 'AV' ? 'YES' : 'NO',
          }
        }), 
        { 
          header : [
            '강의주제명',
            '생성일',            
            '사용여부',
          ], 
          skipHeader : false 
        } 
      );
  
      nurses["!cols"] = [
        { wpx : 150 } 
      , { wpx : 100 } 
      , { wpx : 60 } 
      ]
  
      XLSX.utils.book_append_sheet( book, nurses, "NURSES" );
  
      XLSX.writeFile( book, "강의주제.xlsx" ); 
    }
  }    
  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    if (refCodeList) {
      setTableDatas(refCodeList.map((item) => ({
        ...item,
        key: item.ref_code_srl,
      })));
    } else {
      setTableDatas([]);
    }
  }, [refCodeList]);


  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>기초정보관리</Breadcrumb.Item>
        <Breadcrumb.Item>강의주제</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <div className={cx('tableSearchBoxWrapper')}>
            <Space>
              <Input.Search
                className={cx('searchInput')}
                value={searchInput}
                placeholder="검색어를 입력해 주세요"
                onChange={(e)=>setSearchInput(e.target.value)}
                onSearch={()=>setFilterValue(searchInput)}
                allowClear
              />
              <Button onClick={()=>{
                setSearchInput('');
                setFilterValue('');
              }}>
                검색초기화
              </Button>                
            </Space>
          </div>
          <TotalNumMenu text={' '} useRegister useExcelDownload onDownloadExcel={onDownloadExcel} onUseRegister={onClickRegister} />
          <SortableTable
            dataList={(tableDatas as any[]).filter(item=> filterValue?item.value.includes(filterValue):true)}
            columns={columns}
            onSort={onSort}
            onClick={onRowClick}
          />          
        </Space>                
    </CardLayout>
  )
};

export default LectureSubject;    